import React from 'react';
import './Header.css';
import { useTransition, animated } from 'react-spring';
// import ZapDesignLogo from './img/branding/zapdesign-black.svg'; // <-- Importa il tuo logo qui (adatta il percorso)
import { ReactComponent as ZapDesignLogo } from './img/branding/zapdesign-black.svg';

function Header({ isSidebarCollapsed, activeTopic, onBackClick, onOpenSidebarMenu, isBackTransitionActive, onTopicClick }) {
    const headerLeftMargin = isSidebarCollapsed ? '60px' : '250px';
    // Modificato: Il pulsante BACK ora scompare non appena activeTopic diventa 'none'.
    // `isBackTransitionActive` è ancora utile per orchestrare la transizione del *contenuto* del topic in `ServicesContent`.
    const showBackButton = activeTopic !== 'none'; 

    const transitions = useTransition(showBackButton, {
        from: { opacity: 0, transform: 'translateX(-20px)' },
        enter: { opacity: 1, transform: 'translateX(0px)' },
        leave: { opacity: 0, transform: 'translateX(-20px)' },
        config: { mass: 1, tension: 200, friction: 20, duration: 250 },
    });

    const logoTransitions = useTransition(!showBackButton, { // Inverse della showBackButton
        from: { opacity: 0, transform: 'translateX(-20px)' }, // Appare da sinistra
        enter: { opacity: 1, transform: 'translateX(0px)' },
        leave: { opacity: 0, transform: 'translateX(-20px)' }, // Scompare verso sinistra
        config: { mass: 1, tension: 200, friction: 20, duration: 150 }, // Velocità dell'animazione del logo
    });


    return (
        <div
            id="header"
            style={{
                zIndex: '20',
                
                marginLeft: headerLeftMargin,
                width: `calc(100% - ${headerLeftMargin})`,
                transition: 'margin-left 0.3s ease-in-out, width 0.3s ease-in-out'
            }}
        >
        
        <div id="header-left">
            {logoTransitions((styles, item) =>
                item && ( // Renderizza il logo solo quando item è true (cioè, showBackButton è false)
                    <animated.div className="header-logo-container" style={styles}>
                        <ZapDesignLogo className="zapdesign-logo-svg" />
                    </animated.div>
                )
            )}
            
            {/*
                <div className="header-logo-container">
                    <ZapDesignLogo className="zapdesign-logo-svg" />
                </div>
            */}

            {transitions((styles, item) =>
                item && (
                    <animated.button
                        className="back-button-header"
                        onClick={onBackClick}
                        style={styles}
                    >
                        BACK
                    </animated.button>
                )
            )}
            </div>

            <div id="header-right">
            <button className="menu-toggle-button" onClick={onOpenSidebarMenu}>
                ☰
            </button>

            <button className="contact-popup-link" onClick={() => onTopicClick('contact')}>
                <h1>CONTACT ME</h1>
            </button>
            </div>
        </div>
    );
}

export default Header;
